import { useEffect, useLayoutEffect } from "react";
import { useCookies } from "react-cookie";
import { Outlet } from "react-router-dom";
import { CookiesService } from "@services/CookiesService";

import PageFooter from "@components/common/PageFooter";
import PageHeader from "@components/common/PageHeader";

import { writeCloudFrontCookies } from "@lib/helpers/cloudFrontCookies";
import { useGetCloudFrontCookies } from "@lib/hooks/useGetCloudFrontCookies";

type PageLayoutProps = {
  hideHeader?: boolean;
  hideFooter?: boolean;
};

export default function PageLayout({
  hideHeader,
  hideFooter,
}: PageLayoutProps) {
  const { data: cloudFrontCookies } = useGetCloudFrontCookies();
  const [, setCookie] = useCookies();

  // Clean up legacy storage
  useEffect(() => {
    CookiesService.cleanupLegacyStorage();
  }, []);

  // Handle CloudFront cookies
  useEffect(() => {
    if (cloudFrontCookies) {
      writeCloudFrontCookies(cloudFrontCookies, setCookie);
    }
  }, [setCookie, cloudFrontCookies]);

  // Smooth scroll to top on location change
  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location]);

  return (
    <main className="flex grow flex-col flex-nowrap h-screen p-0 w-full">
      {!hideHeader && (
        <>
          <PageHeader />
          <div className="grow shrink basis-auto h-64px" />
        </>
      )}
      <div className="grow shrink basis-auto">
        <Outlet />
      </div>
      <div className="grow-0 shrink basis-auto">
        {!hideFooter && <PageFooter />}
      </div>
    </main>
  );
}
